import $ from 'jquery';

import {
	restCall,
	getGlobalItem,
	getDOMElements,
	parseStringWithTokens,
	replaceCurlyBraces
} from '../common/utilities.js';

import Modal       from '../common/modal.js';

import Field       from '../field';

import ItemOptions from './options.js';
import Triggers    from './triggers.js';
import Actions     from './actions.js';

import {
	validateItem
} from '../validation/validation';

import RecipeNotices from '../recipe/notices';

import './components/magic-trigger-shortcode';

class ItemHeaderSentence {
	constructor( itemType, integrationID, itemCode, itemId ){
		this.itemType = itemType;
		this.integrationID = integrationID;
		this.itemCode = itemCode;
		this.itemId   = itemId;
		this.item     = UncannyAutomator.recipe.items[ itemId ];

		return this.createItemSentence( itemType, itemCode, itemId );
	}

	/**
	 * Create item sentence + status toggle
	 * 
	 * @since 0.5     
	 *
	 * @return {object}   jQuery DOM object with the item sentence + status toggle
	 */

	createItemSentence( itemType, itemCode, itemId ){
		// Get information about the global item
		let globalItem = getGlobalItem( this.integrationID, itemType, itemCode );
		this.globalItem = globalItem;

		// Get sentence
		let itemSentence;

		if ( ! this.item.isMissing ){
			itemSentence = getGlobalItem( this.integrationID, this.item.itemType, this.item.itemCode ).sentence;
		}
		else {
			itemSentence = this.item.sentence;
		}

		itemSentence = parseStringWithTokens(
			this.item,
			itemSentence,
			UncannyAutomator.recipe.items[ this.itemId ].meta,
			true
		);

		if ( ! this.item.isMissing ){
			// Listen clicks on tokens
			itemSentence.elements.token.on( 'click', ( event ) => {
				// Get token element
				const $token = $( event.currentTarget );

				// Remove "open" class from al items
				itemSentence.elements.token.removeClass( 'item-title__token--open' );
				// Add "open" class to the clicked token
				$token.addClass( 'item-title__token--open' );

				// Add "open" class to the item
				const $item = $token.parents( '.uap-item' );
				$item.addClass( 'uap-item--open' );
				
				/**
				 * @deprecated
				 */
				$item.trigger( 'automator:item:open', true );

				// Get options ID
				let optionsID = $token.data( 'options-id' );

				// Get option group
				let optionGroupDOM = getDOMElements( 'optionGroup', {
					itemID:  itemId,
					groupID: optionsID,
				});

				// Create and show
				new ItemOptions( itemId, optionsID );
			});
		}
			
		// Create DOM elements
		let container = $( '<div/>', { 'class': 'item-title__describe-container' }),
			status    = $( '<div/>', { 'class': 'uap-item-status item-status' });

		container.append( itemSentence.html.addClass( 'item-title__describe' ).attr( 'dir', 'auto' ) );

		// Add an exception for the "Run now" trigger
		if ( this.item.itemCode !== 'RECIPE_MANUAL_TRIGGER_ANON' ){
			// Create toggle. We're using Field. Read Field.js comments for more information
			var itemToggle = new Field( 'checkbox', {
				color: 'green',
				align: 'right',
				toggle: {
					on:  UncannyAutomator._core.i18n.status.liveRecipeItem,
					off: UncannyAutomator._core.i18n.status.draftRecipeItem,
				},
				currentValue: UncannyAutomator.recipe.items[ itemId ].isLive
			});

			let itemStatusToggle = itemToggle.getFormElement();
				status.append( itemStatusToggle );
				container.append( status );

			if ( ! this.item.isMissing ){
				itemStatusToggle.on( 'automator:field:change', () => {
					let makeLive = itemToggle.getValue();
					var isValidItem = true; // True by default, will change to false is it's invalid

					// Check if the user wants to make it live
					if ( makeLive ){
						// Validate
						let validation = validateItem( itemId );
						isValidItem = validation.isValid; 
					}

					// Do AJAX
					// Show loading animation
					itemToggle.startLoadingAnimation();

					if ( isValidItem ){
						// Set post status
						let post_status = makeLive ? 'publish' : 'draft';

						// Check if they want to make an item draft in a live recipe
						if ( ! makeLive && UncannyAutomator._recipe.is_recipe_on ){
							// Create modal box
							// Read Modal.js comments for more information
							let modal = new Modal({
								title:       UncannyAutomator._core.i18n.confirmationModal.title,
								warning:     replaceCurlyBraces( UncannyAutomator._core.i18n.confirmationModal.statusWarning, '<strong>', '</strong>' ),
								buttons: {
									cancel:  UncannyAutomator._core.i18n.cancel,
									confirm: UncannyAutomator._core.i18n.confirm,
								}
							});

							modal.setEvents({
								afterSetEvents: function(){
									modal.show();
								},
								onConfirm: function(){
									let elements        = modal.getElements();
									let confirmButton   = elements.modal.box.buttons.confirm;

									// Add loading class to button
									confirmButton.addClass( 'uap-btn--loading' ).prop( 'disabled', true );

									// Start loading animation on toggle
									itemToggle.startLoadingAnimation();

									// Get the item sentence HTML
									let itemSentenceHTML;
									try {
										itemSentenceHTML = itemSentence.html.get(0).outerHTML;
									} catch ( e ){
										// Continue regardless of error
			
										// Output error if the developer mode is enabled
										if ( UncannyAutomator._site.has_debug_enabled ){
											// eslint-disable-next-line no-console
											console.warn( e );
										}
									}

									restCall( 'change_post_status', {
										recipe_id:   UncannyAutomator._recipe.recipe_id,
										post_ID:      itemId,
										post_status:  post_status,
										sentence_human_readable: itemSentence.brackets,
										sentence_human_readable_html: itemSentenceHTML
									}, function(){
										// On success
										// Destroy modal
										modal.destroy();

										// Refresh UI
										new Triggers();
										new Actions();

										// Show error
										new RecipeNotices();

										// Check if the recipe is still valid, if it isn't then make the recipe draft
										if ( ! UncannyAutomator.recipe.isValid ){
											UncannyAutomator.recipe.publish.statusToggle.setValue( false );
										}
									}, function(){
										// Destroy modal
										modal.destroy();

										// Remove loading animation, data didn't change
										itemToggle.stopLoadingAnimation();

										// Revert user change
										itemToggle.setValue( ! makeLive, false );
									});
								},
								onCancel: function(){
									// Destroy modal
									modal.destroy();
									// Revert user change
									itemToggle.setValue( ! makeLive, false );

									// Stop loading animation in the toggle
									itemToggle.stopLoadingAnimation();
								},
								afterHide: function(){
									modal.destroy();
								}
							});
						}
						else {
							// Get the item sentence HTML
							let itemSentenceHTML;
							try {
								itemSentenceHTML = itemSentence.html.get(0).outerHTML;
							} catch ( e ){
								// Continue regardless of error
			
								// Output error if the developer mode is enabled
								if ( UncannyAutomator._site.has_debug_enabled ){
									// eslint-disable-next-line no-console
									console.warn( e );
								}
							}
									
							// Is valid, make live
							restCall( 'change_post_status', {
								recipe_id:   UncannyAutomator._recipe.recipe_id,
								post_ID:      itemId,
								post_status:  post_status,
								sentence_human_readable: itemSentence.brackets,
								sentence_human_readable_html: itemSentenceHTML
							}, () => {
								// On sucess
								// Update object

								// Refresh UI
								// Render the UI
								new Actions();
								new Triggers();

								// Show error
								new RecipeNotices();

								// Send custom event to the document
								document.dispatchEvent( new CustomEvent( 'uap/builder/legacy/item-changed-status', {
									detail: {
										itemID: itemId,
										postStatus: post_status,
										itemType: this.item.itemType,
										integrationCode: this.item.integrationCode,
										itemCode: this.item.itemCode,
									}
								} ) );
							}, () => {
								// Remove loading animation, data didn't change
								itemToggle.stopLoadingAnimation();

								// Revert user change
								itemToggle.setValue( ! makeLive, false );
							});
						}
					}
					else {
						// JS won't take more than some milliseconds to do this, so we're going to wait one second just for the user to understand what's happening
						setTimeout(function(){
							// Remove loading animation
							itemToggle.stopLoadingAnimation();

							// Revert user change
							itemToggle.setValue( false, false );
						}, 1000 );
					}
				});

				// Check if this is magic link or button trigger
				if ( this.item.integrationCode === 'MAGIC_BUTTON' ) {
					// Add a class to the container for styling.
					container.addClass( 'magic-button-item' );
					
					// Create and append the magic trigger shortcode element.
					const magicShortcode = document.createElement('uap-builder-magic-trigger-shortcode');
					magicShortcode.sentence = itemSentence.plain;
					magicShortcode.setAttribute( 'item-id', this.itemId );
					magicShortcode.setAttribute( 'item-code', this.item.itemCode );
					itemSentence.html.append( magicShortcode );
				}
			}
		}

		return container;
	}
}

export default ItemHeaderSentence;
